import { configureStore } from '@reduxjs/toolkit'
import countryReducer from './slice/countrySlice'
import entityTanReducer from './slice/entityTanSlice.js'
import navigationReducer from './slice/navigationSlice'
import mtEntityTanReducer from './slice/mtEntityTanSlice'
import userReducer from './slice/userSlice'
import selfServiceReducer from './slice/selfServiceSlice';
import dashboardFilterReducer from './slice/dashboardFilterSlice';


const store = configureStore({
  reducer: {
    entityTan: entityTanReducer,
    mtEntityTan: mtEntityTanReducer,
    user: userReducer,
    country: countryReducer,
    navigation: navigationReducer,
    selfService: selfServiceReducer,
    dashboardFilter: dashboardFilterReducer,
  },
})

export default store

